export const rand = (min, max) => {
    min = Math.ceil(min)
    max = Math.floor(max)  
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export const hasRole = (user, role) => {
    console.log("ROLE", user.data)
    if(user.data?.roles?.includes('*')) return true
    if(user.data?.roles?.includes(role)) return true
    return false
}